var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Demographics")]),
      _c("gender-radio", {
        model: {
          value: _vm.entity.gender,
          callback: function($$v) {
            _vm.$set(_vm.entity, "gender", $$v)
          },
          expression: "entity.gender"
        }
      }),
      _c(
        "md-layout",
        { attrs: { "md-gutter": 24 } },
        [
          _c(
            "md-layout",
            { attrs: { "md-flex": "50", "md-flex-small": "100" } },
            [
              _c("age-selector", {
                attrs: { multiple: true },
                model: {
                  value: _vm.entity.ages,
                  callback: function($$v) {
                    _vm.$set(_vm.entity, "ages", $$v)
                  },
                  expression: "entity.ages"
                }
              })
            ],
            1
          ),
          _c(
            "md-layout",
            { attrs: { "md-flex": "50", "md-flex-small": "100" } },
            [
              _c("education-selector", {
                attrs: { multiple: true },
                model: {
                  value: _vm.entity.educations,
                  callback: function($$v) {
                    _vm.$set(_vm.entity, "educations", $$v)
                  },
                  expression: "entity.educations"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "md-layout",
        { attrs: { "md-gutter": 24 } },
        [
          _c(
            "md-layout",
            { attrs: { "md-flex": "50", "md-flex-small": "100" } },
            [
              _c("house-hold-selector", {
                attrs: { multiple: true },
                model: {
                  value: _vm.entity.households,
                  callback: function($$v) {
                    _vm.$set(_vm.entity, "households", $$v)
                  },
                  expression: "entity.households"
                }
              })
            ],
            1
          ),
          _c(
            "md-layout",
            { attrs: { "md-flex": "50", "md-flex-small": "100" } },
            [
              _c("income-selector", {
                attrs: { multiple: true },
                model: {
                  value: _vm.entity.incomes,
                  callback: function($$v) {
                    _vm.$set(_vm.entity, "incomes", $$v)
                  },
                  expression: "entity.incomes"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d07026f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d07026f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/DemographicForm.vue
// module id = 929
// module chunks = 0